/* eslint-disable no-trailing-spaces, max-len */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 32,
  },
  title: {
    textAlign: 'center',
    fontWeight: 700,
  },
  termsAndConditions: {
    textAlign: 'justify',
    marginBottom: theme.spacing(4),
  },
  li: {
    marginTop: theme.spacing(2),
  },
  tocList: {
    paddingLeft: 20,
  },
}));

const TermsAndConditions = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.title}>
        CARTIER WORLD MEETING 2026: CONFIDENTIALITY UNDERTAKING
        <br />
      </div>
      <div className={classes.termsAndConditions}>
        <p>By accessing information related to the Cartier World Meeting 2026 taking place June 29 - July 2, 2026 in Italy, you acknowledge and agree to the following, reinforcing your existing confidentiality obligations to Cartier:</p>
        <p>You will be provided with and/or have access to highly confidential and sensitive proprietary information, including new CARTIER products, business strategy plans etc. (collectively, &quot;<strong>Confidential Information</strong>&quot;). This information is provided solely for the purpose of projecting and planning your participation in Cartier’s worldwide presentation, launch, and sales of its new collections (&quot;<strong>Purpose</strong>&quot;).</p>
        <p><strong>You undertake and acknowledge that:</strong></p>
        <ul className={classes.tocList}>
          <li><strong>Ownership:</strong> All Confidential Information remains the exclusive property of CARTIER. This undertaking does not grant you any ownership or intellectual property rights.</li>
          <li><strong>Strict Confidentiality:</strong> You shall keep all Confidential Information strictly confidential. It must not be disclosed, directly or indirectly, to anyone except Cartier employees who have a need to know for the Purpose.</li>
          <li><strong>Limited Use:</strong> Confidential Information shall be used solely for the stated Purpose.</li>
          <li><strong>No Disclosure of Meeting Details:</strong> You must not divulge, directly or indirectly, to anyone, the content of this undertaking, the fact that Confidential Information has been sent to you, your potential participation in the Cartier Meetings, or its progress. You also undertake not to make any public declaration or reference in connection with the Cartier Meetings.</li>
          <li><strong>No Reproduction:</strong> It is expressly forbidden to make any copies, photographs, videos, and/or sound recordings of any part of the Confidential Information, including CARTIER products or presentations given during the Cartier Meetings.</li>
          <li><strong>Reporting Breaches:</strong> You must immediately inform Cartier if you observe or suspect any unauthorised disclosure of Confidential Information.</li>
          <li><strong>Return/Destruction:</strong> Upon Cartier’s request, you shall destroy and/or return all Confidential Information.</li>
          <li><strong>Duration:</strong> These confidentiality obligations shall remain in force until such time CARTIER has chosen to publicly disclose the Confidential Information.</li>
        </ul>
      </div>
    </div>
  );
};

export default TermsAndConditions;
